import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from "../../../shared/services/auth/auth.service";
import {UserType} from "../../../shared/model/user-type";
import {ACLINFO} from "../../../../gen/swagger-api";

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent implements OnInit {

  constructor(private router: Router, private authenticationService: AuthService) { }
  public unreadNotifications: number = 0;

  @Input("origin")
  public origin: string;

  public username: string;
  public privileges: ACLINFO;
  public userType : UserType;
  public userTypeEnum = UserType; //to use enum in ngIf

  ngOnInit() {
    // this.loadUnreadNotifications(100);
    this.username = sessionStorage.getItem('username');
    this.userType = UserType[sessionStorage.getItem('userType')];
    this.privileges = JSON.parse(sessionStorage.getItem('privileg-' + this.username));
  }
  // public loadUnreadNotifications (limit: number){
  //   this.defaultService.usersNotificationsGet(0,limit,true).subscribe(
  //     notifications => this.unreadNotifications = notifications.length
  //   );
  // }
  public logout() {
    this.authenticationService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/shared/nav-header/nav-header.component.ts